var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5714 7.90628C14.4037 8.18804 15 8.94838 15 9.84211V13.9474C15 15.081 14.0406 16 12.8571 16H7.14286C5.95939 16 5 15.081 5 13.9474V9.84211C5 8.94838 5.59629 8.18804 6.42857 7.90628V6.42105C6.42857 4.53166 8.02756 3 10 3C11.9724 3 13.5714 4.53166 13.5714 6.42105V7.90628ZM7.85714 7.78947H12.1429V6.42105C12.1429 5.28741 11.1835 4.36842 10 4.36842C8.81653 4.36842 7.85714 5.28741 7.85714 6.42105V7.78947ZM10 9.84211C9.21101 9.84211 8.57143 10.4548 8.57143 11.2105C8.57143 11.717 8.85871 12.1593 9.28571 12.3959V13.9474H10.7143V12.3959C11.1413 12.1593 11.4286 11.717 11.4286 11.2105C11.4286 10.4548 10.789 9.84211 10 9.84211Z",
    fill: "#0B3B61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.66928d5d5ad761606939e01f14c3bc3c.svg";
export { ForwardRef as ReactComponent };